/*
 * 管理者がほかの人の2要素認証を外すときの「理由」を、送る形にする（2026-10-11、監査 WF-3）。
 *
 * サーバ（MfaAdminRecoveryService の reasonToStore）と同じ決まり。
 *  1. 前後の空白を落とす（半角・全角の空白、タブ、改行）。
 *  2. 残りが1文字以上200文字以内であること。
 *  3. 残りに制御文字（改行・タブも）が無いこと（欄は1行の入力）。
 *
 * **検査した文字列そのものを送る**（入力欄の生の値を送らない）。検査した値と送る値が別だと、
 * 画面は通ってサーバで断られる・その逆、ができる。サーバでは、検査を通ったあとで保存の前に
 * 空へ変わる理由（U+0000 だけ）で、理由なしのまま外せていた。
 */

/* 理由の長さの上限（記録の列の長さ。サーバも同じ数で断る）。 */
export const RESET_REASON_MAX_LENGTH = 200

/* 前後から落とす空白。\s（半角・全角の空白、タブ、改行など）と、サーバが空白として落とす U+001C〜U+001F。 */
// eslint-disable-next-line no-control-regex
const SURROUNDING_BLANKS = /^[\s\u001c-\u001f]+|[\s\u001c-\u001f]+$/g

/* 制御文字（U+0000〜U+001F・U+007F〜U+009F）。 */
// eslint-disable-next-line no-control-regex
const CONTROL_CHARACTER = /[\u0000-\u001f\u007f-\u009f]/

/** 送る理由。受け取れない理由（空・200文字超・制御文字入り）なら null。 */
export function resetReasonToSend (value) {
  const text = String(value === null || value === undefined ? '' : value)
    .replace(SURROUNDING_BLANKS, '')
  if (text.length < 1 || text.length > RESET_REASON_MAX_LENGTH) return null
  if (CONTROL_CHARACTER.test(text)) return null
  return text
}
